import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ListOptionVariant } from '@app/models/asset';

@Component({
    selector: 'pr-form-select-list-option',
    templateUrl: './pr-form-select-list-option.component.html',
    styleUrls: ['./pr-form-select-list-option.component.scss'],
    standalone: false
})
export class PrFormSelectListOptionComponent implements OnInit {
  @Input() label: string;
  @Input() labelIcon: string;
  @Input() tooltipIcon: string;
  @Input() tooltip: string;
  @Input() subLabel: string;
  @Input() infoLabel: string;
  @Input() infoClass: string;
  @Input() variant: ListOptionVariant = 'DEFAULT';
  @Input() criterias: {
    label: string;
    value: string;
    options: { color: string };
  }[];
  @Input() criteriasLoading: boolean = false;

  @Input() selected: boolean;

  @Input() withMoreInfoAnchor: boolean = true;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onMoreInfoClick: EventEmitter<any> = new EventEmitter();
  @Output() onDeselect: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
